function setCookie(key, value, days = 365) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; SameSite=Strict; Secure`;
}

let redirects = [];
window.addEventListener('message', (event) => {
  if (event.data.type === 'app') {
    window.parent.postMessage({
      type: 'navigation',
      title: document.title,
      href: window.location.href,
    }, '*');
    Object.entries(event.data.cookies).forEach(([key, value]) => {
      if (['true', 'false'].includes(value)) {
        setCookie(key, value);
      }
    });
    redirects = event.data.redirects || [];
  }

  const windowHostname = new URL(window.location.href).hostname;
  document.querySelectorAll('a')
    .forEach((link) => {
      const hasTargetBlank = link.getAttribute('target') === '_blank';
      const isInternalLink = ((link.href && new URL(link.href).hostname === windowHostname) || link.href.startsWith('/'));
      if (!hasTargetBlank && !isInternalLink) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer nofollow');
      }
      if (isInternalLink) {
        const linkUrl = new URL(link.href);
        const redirectPath = redirects[linkUrl.pathname.split('/').at(-1)];
        if (redirectPath) {
          link.addEventListener('click', (clickEvent) => {
            clickEvent.preventDefault();
            window.parent.postMessage({
              type: 'navigationtoreact',
              href: `${redirectPath}${linkUrl.search}`,
            }, '*');
          });
        }
      }
    });
});
